import React, { Component } from 'react';
import { connect } from 'react-redux';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import HeaderFixed from './HeaderFixed';
import HeaderScrolling from './HeaderScrolling';
import BrandLogo from './BrandLogo';
import TransitionChild from '../common/TransitionChild';
import '../../css/react-css-transitions.scss';

export class Header extends Component {
  constructor() {
    super();
    this.state = {
      showScrollingHeader: false,
    };

    this.handleScroll = this.handleScroll.bind(this);
  }

  handleScroll() {
    const { showScrollingHeader } = this.state;
    const { scrollY } = window;

    if (scrollY > 0 && showScrollingHeader === false) {
      this.setState({
        showScrollingHeader: true,
      });
    }

    if (scrollY === 0 && showScrollingHeader === true) {
      this.setState({
        showScrollingHeader: false,
      });
    }
  }

  componentDidMount() {
    this.handleScroll();
    window.addEventListener('scroll', this.handleScroll);
  }

  render() {
    const { showScrollingHeader } = this.state;
    const {
      isMobile, pageType, onMenuClick, articleHed, standardArticleTracker,
    } = this.props;

    const HeaderMenuButton = <div className="header-icon header-icon-menu icon-menu-icon-desktop-nav"/>;
    const HeaderLogo = <BrandLogo mark={isMobile} />;
    const HeaderLogoMark = <BrandLogo mark={true} />
    const HeaderEmailButton = <div className="share header-icon header-icon-email" />;

    // HeaderScrolling
    const renderedHeaderScrolling = (
      <HeaderScrolling
        HeaderMenuButton={HeaderMenuButton}
        HeaderLogo={HeaderLogoMark}
        articleHed={articleHed} />
    );

    const shouldShowScrollingHeader = showScrollingHeader && !isMobile && (typeof pageType !== 'undefined' && pageType.includes('article'));

    return (
      <div className="header">
        {/* renders on all pages and when scrollTop is 0 on articles */}
        <HeaderFixed
          isMobile={isMobile}
          HeaderLogo={HeaderLogo}
          HeaderMenuButton={HeaderMenuButton}
          standardArticleTracker={standardArticleTracker}
          articleHed={articleHed}
        />
        </div>
        //{/* renders on articles when scrollTop > 0 and not mobile */}
        // <ReactCSSTransitionGroup
        //   key="global-header-scrolling"
        //   transitionName="slide-y-ttb"
        //   transitionEnterTimeout={500}
        //   transitionLeaveTimeout={500}
        //   component={TransitionChild}
        // >
        //   {shouldShowScrollingHeader && renderedHeaderScrolling}
        // </ReactCSSTransitionGroup>

      
    );
  }
}


const mapStateToProps = ({
  isMobile, pageData, standardArticleTracker,
}) => {
  const { pageType } = pageData;
  const articleHed = pageType === 'article' ? pageData.article.name : pageData.title;

  return {
    isMobile,
    articleHed,
    pageType,
    standardArticleTracker,
  };
};

const mapDispatchToProps = dispatch => ({
  onMenuClick: () => {
    dispatch({
      type: 'SIDEBAR_TOGGLE',
    });
  },
});

export const HeaderContainer = connect(mapStateToProps, mapDispatchToProps)(Header);

export default HeaderContainer;
